module.exports = __webpack_public_path__ + "static/approach-diagram.e348faca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/approach-diagram.png
// module id = 1138
// module chunks = 35783957827783